import { getCurrentTime } from "sb-resp-lib";

export const getISODate = (dateISOString: string, currentTimeZone: number) => {
    let convertedDate = Date.fromISO(dateISOString);
    return convertedDate ? getCurrentTime(convertedDate, currentTimeZone) : undefined;
}